import { Form } from "@/components/organisms/Form";
import { Buttons } from "@/components/atoms/Buttons";
import { useNavigate } from "react-router";
import { MainTemplate } from "@/components/templates/MainTemplate";
import { AlertMessageBox } from "@/components/molecules/AlertMessageBox";
import { ReactComponent as IconChecked } from "@/styles/assets/svg/icon_checked_large.svg";

export const PhotoDonePage = () => {
  const navigate = useNavigate();

  return (
    <MainTemplate nav={false} subPage={true} menuBtn={false}>
      <Form
        submitBtn={
          <Buttons
            type="button"
            size="lg"
            layout="solid"
            color="primary100"
            label="건강평가 결과 보기"
            onClick={() => navigate("/spine", { replace: true })}
          />
        }
        backBtn={
          <Buttons
            type="button"
            size="lg"
            layout="text"
            color="primary100"
            label="홈으로"
            onClick={() => navigate("/home", { replace: true })}
          />
        }
      >
        <AlertMessageBox
          color="white"
          icon={<IconChecked />}
          title="사진 등록 완료"
          text={<>사진 등록이 성공적으로 완료되었습니다.</>}
        />
      </Form>
    </MainTemplate>
  );
};
